import React from 'react';
import { connect } from 'react-redux';
import { Spinner } from 'reactstrap';
import { getCampaigns } from '../../actions/campaign';
import CampaignRow from './CampaignRow';

class CampaignList extends React.PureComponent {
  componentDidMount() {
    getCampaigns();
  }

  render() {
    const {
      campaigns,
      campaignsLoading,
    } = this.props;

    return (
      <tbody>
        {campaignsLoading ? (
          <tr>
            <td colSpan="13">
              <div className="m-4 text-center">
                <Spinner style={{ width: '5rem', height: '5rem' }} type="grow" color="info" />
                <Spinner style={{ width: '5rem', height: '5rem' }} type="grow" color="info" />
                <Spinner style={{ width: '5rem', height: '5rem' }} type="grow" color="info" />
              </div>
            </td>
          </tr>
        ) : campaigns.map((campaign) => (
          <CampaignRow key={campaign.id} campaign={campaign} />
        ))}
      </tbody>
    );
  }
}

const mapStateToProps = (store) => ({
  campaigns: store.campaign.list,
  campaignsLoading: store.campaign.loading,
});

export default connect(mapStateToProps)(CampaignList);
